'use strict';
import '../../sass/merchandise.scss';
export function MerchandiseBlock(model) {
  Object.defineProperties(this, {
    "id": {
      get: function() {return this._id;},
      set: function(value) {
        if(!value) {
          throw new TypeError('idプロパティ値が指定されていません。');
        }
        this._id = value;
      },
      enumerable: true
    },
    "title": {
      get: function() {return this._title;},
      set: function(value) {
        if(!value) {
          throw new TypeError('titleプロパティ値が指定されていません。');
        }
        this._title = value;
      },
      enumerable: true
    },
    "masterURL": {
      get: function() {return this._masterURL;},
      set: function(value) {
        this._masterURL = value || null;
      },
      enumerable: true
    },
    "charactors": {
      get: function() {return this._charactors;},
      set: function(values) {
        if(!values) {
          throw new TypeError('charactorsプロパティ値が指定されていません。');
        }
        this._charactors = values;
      },
      enumerable: true
    },
    "imageCount": {
      get: function() {return this._imageCount;},
      set: function(value) {
        if(!value) {
          throw new TypeError('imageCountプロパティ値が指定されていません。');
        }
        this._imageCount = value;
      },
      enumerable: true
    },
    "images": {
      get: function() {return this._image;},
      set: function(values) {
        if(!values) {
          throw new TypeError('imagesプロパティ値が指定されていません。');
        }
        this._image = values;
      },
      enumerable: true
    },
    "maker": {
      get: function() {return this._maker;},
      set: function(value) {
        if(!value) {
          throw new TypeError('makerプロパティ値が指定されていません。');
        }
        this._maker = value;
      },
      enumerable: true
    },
    "releaseDate": {
      get: function() {return this._releaseDate;},
      set: function(value) {
        if(!value) {
          throw new TypeError('releaseDateプロパティ値が指定されていません。');
        }
        this._releaseDate = value;
      },
      enumerable: true
    },
    "authority": {
      get: function() {return this._authority;},
      set: function(value) {
        if(!value) {
          throw new TypeError('authorityプロパティ値が指定されていません。');
        }
        this._authority = value;
      },
      enumerable: true
    },
    "category": {
      get: function() {return this._category;},
      set: function(value) {
        if(!value) {
          throw new TypeError('categoryプロパティ値が指定されていません。');
        }
        this._category = value;
      },
      enumerable: true
    },
    "discription": {
      get: function() {return this._discription;},
      set: function(value) {
        if(!value) {
          throw new TypeError('discriptionプロパティ値が指定されていません。');
        }
        this._discription = value;
      },
      enumerable: true
    },
    "spec": {
      get: function() {return this._spec;},
      set: function(value) {
        if(!value) {
          throw new TypeError('specプロパティ値が指定されていません。');
        }
        this._spec = value;
      },
      enumerable: true
    },
    "price": {
      get: function() {return this._price;},
      set: function(value) {
        if(!value) {
          throw new TypeError('priceプロパティ値が指定されていません。');
        }
        this._price = value;
      },
      enumerable: true
    }
  });
  this.id = model.id;
  if('title' in model && model.title.length > 0) {
    this.title = model.title;
  }
  if('masterUrl' in model && model.masterUrl.length > 0) {
    this.masterURL = model.masterUrl;
  }
  if('charas' in model) {
    this.charactors = model.charas;
  }
  if('imgCnt' in model) {
    this.imageCount = model.imgCnt;
  }
  if('imgs' in model) {
    this.images = model.imgs;
  }
  if('maker' in model && model.maker.length > 0) {
    this.maker = model.maker;
  }
  if('releaseDate' in model && model.releaseDate.length > 0) {
    this.releaseDate = model.releaseDate;
  }
  if('authority' in model) {
    this.authority = model.authority;
  }
  this.category = model.category;
  if('discription' in model && model.discription.length > 0) {
    this.discription = model.discription;
  }
  if('spec' in model && model.spec.length > 0) {
    this.spec = model.spec;
  }
  if('price' in model) {
    this.price = model.price;
  }
};
MerchandiseBlock.prototype.create = function() {
  var df = document.createDocumentFragment();
  var section = document.createElement('div');
  section.className = 'section section--merchandise';
  section.dataset.id = this.id;
  df.appendChild(section);

  var header = section.cloneNode(false);
  header.className = 'header--merchandise';
  header.removeAttribute('data-id');
  df.firstChild.appendChild(header);

  var headline = document.createElement('h2');
  var headlineAnchor = document.createElement('a');
  if(this.masterURL) {
    headlineAnchor.href = this.masterURL;
    headlineAnchor.innerHTML = this.title;
    headline.appendChild(headlineAnchor);
  } else {
    headline.innerHTML = this.title;
  }
  df.querySelector('.header--merchandise').appendChild(headline);

  if('category' in this) {
    var tag = document.createElement('p');
    tag.className = 'tag tag--' + this.category.id;
    var tagAnchor = headlineAnchor.cloneNode(false);
    tagAnchor.href = '?type=category&id=' + this.category.id;
    tagAnchor.textContent = this.category.name;
    tag.appendChild(tagAnchor);
    df.querySelector('.header--merchandise').appendChild(tag);
  }

  var imageContainer = header.cloneNode(false);
  imageContainer.className = 'container--merchandise-image';
  if(this.imageCount > 0) {
    this.images.forEach(function(image, i) {
      var thumb = document.createElement('img');
      thumb.src = image.imgSrc;
      thumb.alt = image.altName;
      thumb.className = 'image--merchandise-thumbnail';

      var wrapper = imageContainer.cloneNode(false);
      wrapper.className = '';
      wrapper.removeAttribute('class');
      if('link' in image) {
        var thumbAnchor = headlineAnchor.cloneNode(false);
        thumbAnchor.href = image.link;
        thumbAnchor.className = 'anchor--merchandise-image';
        thumbAnchor.appendChild(thumb);
        wrapper.appendChild(thumbAnchor);
      } else {
        wrapper.appendChild(thumb);
      }
      imageContainer.appendChild(wrapper);
    });
    df.firstChild.appendChild(imageContainer);
  }

  var detail = document.createElement('ul');
  detail.className = 'list--merchandise-detail';
  var listitem = document.createElement('li');
  listitem.className = 'listitem--merchandise-detail';
  if(this.releaseDate && this.releaseDate.length > 0) {
    detail.appendChild(this.createListitem('発売月', this.releaseDate));
  }
  if(this.price && this.price.length > 0) {
    detail.appendChild(this.createListitem('価格', this.price, false));
  }
  if(this.maker && this.maker.length > 0) {
    detail.appendChild(this.createListitem('メーカー', this.maker, false));
  }
  if(this.discription && this.discription.length > 0) {
    detail.appendChild(this.createListitem('商品説明', this.discription, false));
  }
  if(this.spec && this.spec.length > 0) {
    detail.appendChild(this.createListitem('商品仕様', this.spec, false));
  }
  if(this.authority &&
    ('name' in this.authority && this.authority.name.length > 0)) {
    detail.appendChild(this.createListitem('原作', this.authority.name));
  }
  if(this.charactors && this.charactors.length > 0) {
    var listitem = document.createElement('li');
    listitem.className = 'listitem--merchandise-detail';
    listitem.appendChild(this.createListHead('キャラクター'));

    var rightBlock = document.createElement('div');
    this.charactors.forEach(function(charactor) {
      if(('chara' in charactor && charactor.chara.length > 0) &&
        ('id' in charactor && charactor.id.length > 0)) {
        var rightBlockAnchor = document.createElement('a');
        rightBlockAnchor.href = '?type=chara&id=' + charactor.id;
        rightBlockAnchor.className = 'anchor--merchandise-charactor';
        rightBlockAnchor.textContent = charactor.chara;
        rightBlock.appendChild(rightBlockAnchor);
      } else if(('chara' in charactor && charactor.chara.length > 0) &&
        ('id' in charactor && charactor.id.length === 0)) {
        if(rightBlock.childNodes.length > 0) {
          var space = document.createTextNode('\u0020');
          rightBlock.appendChild(space);
        }
        var charactorName = document.createTextNode(charactor.chara)
        rightBlock.appendChild(charactorName);
        rightBlock.normalize();
      }
    });
    listitem.appendChild(rightBlock);
    detail.appendChild(listitem);
  }
  df.firstChild.appendChild(detail);
  return df;
};
MerchandiseBlock.prototype.createListHead = function(value) {
  var element = document.createElement('div');
  element.className = 'listhead--merchandise-detail';
  element.textContent = value;
  return element;
};
MerchandiseBlock.prototype.createListitem = function(listheadValue, rightBlockContent, isTextNode) {
  if(isTextNode === undefined) {
    isTextNode = true;
  }
  var listitem = document.createElement('li');
  listitem.className = 'listitem--merchandise-detail';
  listitem.appendChild(this.createListHead(listheadValue));

  var rightBlock = document.createElement('div');
  if(isTextNode) {
    rightBlock.textContent = rightBlockContent;
  } else {
    rightBlock.innerHTML = rightBlockContent;
  }
  listitem.appendChild(rightBlock);
  return listitem;
};